<h2 mat-dialog-title>{{data.dialogTitle}}</h2>
<mat-dialog-content *ngIf="!data.createFile">
  <span>{{data.content}}</span>
</mat-dialog-content>

<mat-dialog-content *ngIf="data.createFile">
  <br><br>
  <mat-label style="align-self: flex-start">Session </mat-label>
  <input style="font-size: 16px;" matInput placeholder="Insert session name..." (input)="onFileNameChange($event)">
  <br>
  <br>
  <p *ngIf="showMessage">{{message}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="data.createFile">
  <button mat-button (click)="onCreateFile()" [disabled]="createBtnDisabled">{{data.newButtonName}}</button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>

<mat-dialog-actions align="end" *ngIf="!data.createFile">
  <button mat-flat-button color="{{data.newBtnColor}}" *ngIf="data.newButton" (click)="onButtonClick()">{{data.newButtonName}}</button>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>


